// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__59olt","container":"Skills_container__KxIh4","skills":"Skills_skills__-78fY"};